<template>
  <div class="order-history-card padding-xs align-justify grid-y">
    <a :href="orderUrl" class="card-href align-justify auto grid-y">
      <div class="auto align-justify grid-x">
        <div class="cell auto grid-y">
          <div v-if="brand === 'mcom'" class="bag-large margin-bottom-xxs"></div>
          <div class="align-justify grid-x">
            <div>
              <p class="small">{{ orderDate }}</p>
              <p class="gray-1-color small">Order number: {{ order.orderNumber }}</p>
            </div>
          </div>
        </div>
        <div v-if="showThumbnails" class="grid-x align-right">
          <div v-for="(item, index) in order.items.slice(0, 2)" :key="item.upc" class="thumbnail">
            <img
              :src="imgSrc(item)"
              width="60"
              height="73"
              class="padding-xxs"
              alt=""
              :loading="index === 0 ? 'eager' : 'lazy'"
              :fetchpriority="index === 0 ? 'high' : 'low'"
            />
          </div>
        </div>
      </div>
      <div v-if="showProtectionPlanLabel" class="auto align-justify grid-x margin-top-xxs">
        <div class="cell auto grid-y">
          <div class="align-justify grid-x">
            <div>
              <p class="small">{{ order.protectionPlanLabel }}</p>
            </div>
          </div>
        </div>
      </div>
    </a>
    <a :href="orderUrl" class="align-justify grid-x margin-top-xs">
      <p class="small toggle_details">View Details</p>
      <p v-if="showMoreItemsCount" class="padding-right-xxs small">+ {{ order.totalOrderItems - 2 }} items</p>
    </a>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { brand } from 'config';
import NoImage from '@/assets/img/no-image-available.png';

const props = defineProps({
  order: {
    type: Object,
    default: () => ({}),
    required: true,
  },
  myAccountGetThumbnailEnabled: {
    type: Boolean,
    default: false,
  },
});

const isThumbnailEnabled = computed(() => props.myAccountGetThumbnailEnabled);
const showThumbnails = computed(() => isThumbnailEnabled.value && props.order.items?.length > 0);
const showMoreItemsCount = computed(() => isThumbnailEnabled.value && props.order.totalOrderItems > 2);
const orderUrl = computed(() => `/purchases/online/${props.order.orderNumber}?linklocation=pagecontent`);
const orderDate = computed(() => {
  if (props.order.orderDate) {
    return props.order.orderDate;
  }
  const date = new Date(props.order.orderDateFormatted);
  const dateArray = date.toDateString().split(' ');
  return `${dateArray[1]} ${dateArray[2]}, ${dateArray[3]}`;
});
const showProtectionPlanLabel = computed(() => props.order.withProtectionPlan && props.order.protectionPlanLabel);

const imgSrc = (item) => {
  if (item.product.imagery?.primaryImage?.filePath) {
    return item.product.imagery.urlTemplate + item.product.imagery.primaryImage.filePath;
  }
  return NoImage;
};
</script>

<style lang="scss" scoped>
@import '@csgIcons/_bag-large.scss';

.order-history-card {
  border: $gray-3-border;
  min-height: rem-calc(139);
  height: 100%;

  p {
    margin-bottom: 0;
  }

  .card-href {
    text-decoration: none;
  }

  .toggle_details {
    text-decoration: underline;
  }
}
</style>
<style lang="scss" brand="mcom" scoped>
.order-history-card {
  border-radius: 5px;
}
</style>
